import { drawing } from '@progress/kendo-drawing';
import { COORD_PRECISION } from './constants';

export default function interpolateValue(start, end, progress) {
    return drawing.util.round(start + (end - start) * progress, COORD_PRECISION);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-charts/dist/es/common/interpolate-value.js
// module id = 2364
// module chunks = 29